/**
 * @file 数据源相关接口
 */

import { http } from '@/utils/http';

const baseUrl = '/v1';

// 获取数据库信息
export const reqFetchUserInfo = () =>
  http.request({
    url: `${baseUrl}/self/info`,
    method: 'GET'
  });

/**
 * Region
 */
// 获取地域列表
export const reqFetchRegions = () =>
  http.request({
    url: `${baseUrl}/public/listsDmsRegion`,
    method: 'GET'
  });

/**
 * 内部数据源
 */
// 获取实例列表
export const reqFetchInstances = (regionId) =>
  http.request({
    url: `/self/listsInstance`,
    method: 'GET',
    params: {
      regionId
    }
  });

// 获取数据源实例详情
export const reqShowInstance = (cloudId, dbType, instanceId) =>
  http.request({
    url: `/instance/${cloudId}/${dbType}/${instanceId}/detail`,
    method: 'GET'
  });

// 登录内部数据源，返回 dataSourceId
export const reqLoginInstance = (dbType, params) =>
  http.request({
    url: `${baseUrl}/${dbType}/conn`,
    method: 'GET',
    params: params
  });

/**
 * 外部数据源
 */
// 获取外部数据源
export const reqFetchDataSources = () =>
  http.request({
    url: `/datasource`,
    method: 'GET'
  });

// 添加外部数据源
export const reqCreateDataSource = data =>
  http.request({
    url: `/datasource`,
    method: 'POST',
    showLoading: true,
    data
  });

// 编辑外部数据源
export const reqEditDataSource = ({ id, ...data }) =>
  http.request({
    url: `/datasource/${id}`,
    method: 'PUT',
    data,
    showLoading: true
  });

// 删除外部数据源
export const reqDestroyDataSource = id =>
  http.request({
    url: `/datasource/${id}`,
    method: 'DELETE',
    showLoading: true
  });

// 测试外部数据源
export const reqTestDataSource = data =>
  http.request({
    url: `/datasource/test`,
    method: 'POST',
    data,
    showLoading: true
  });
